import React from "react";

// import {TransactionContext} from "../../../../../context";
// import {CustomBadges, TableLoading, TableNullData} from "../../../../../components";

import "./index.scss";
import {
  CustomButton2,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../../../components";
import utils from "../../../../../../utils";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";
import convertNumberToPrice from "../../../../../../utils/convertNumberToPrice";
import convertGregorianToJalali from "../../../../../../utils/convertGregorianToJalali";

type Props = {
  data: any;
};

const Body = ({ data }: Props) => {
  const {
    requestDriverTransaction,
    setShowModal,
    setSelected,
  } = React.useContext(Context.DriverTransactionScreen);

  const [openInfoModal, setOpenInfoModal] = React.useState<boolean>(false);
  const docs = data?.data?.result?.docs;

  function onClickInfo() {
    setOpenInfoModal(!openInfoModal);
  }

  function onClickRow(index: number) {
    // setSelectedUserId(index);
    // setShowModal("SHOW");
  }

  const { t } = useTranslation();

  if (!docs || docs?.length <= 0) return <TableNullData />;
  return (
    <>
      <tbody id="find-transaction-body-container">
        {docs?.map((debt: any, index: number) => {
          return (
            <tr key={`files-tr-${index}`} onClick={() => onClickRow(debt?.debtId?._id)}>
              <td onClick={onClickInfo}>
                <div className="table-index-number">
                  {requestDriverTransaction.page === 1 ?
                    index + 1 : (requestDriverTransaction.page - 1) * 10 + index + 1}
                </div>
              </td>
              <td onClick={onClickInfo}>
                <UserInformation
                  name={debt?.driver?.firstName + " " + debt?.driver?.lastName}
                  phoneNumber={debt?.driver?.phoneNumber}
                  hideAvatar
                />
              </td>
              <td onClick={onClickInfo}>
                {convertNumberToPrice(debt?.totalAmount)} {"تومان"}
              </td>
              <td onClick={onClickInfo}>
                {convertNumberToPrice(debt?.paidAmount)} {"تومان"}
              </td>
              <td onClick={onClickInfo}>
                {debt?.isPaid2Driver && "پرداخت به راننده"}
                {debt?.isPaid4Driver && "دریافت از راننده"}
              </td>
              <td onClick={onClickInfo}>
                {convertNumberToPrice(
                  debt?.shares.admin + debt?.shares.company
                )}{" "}
                {"تومان"}
              </td>
              <td onClick={onClickInfo}>
                {convertNumberToPrice(debt?.shares.admin)} {"تومان"}
              </td>
              <td onClick={onClickInfo}>{debt?.countFactors}</td>
              <td onClick={onClickInfo} className="table-text">
                {t(debt?.payerType)}
              </td>
              <td onClick={onClickInfo}>
                {convertGregorianToJalali({
                  date: debt?.createdAt,
                  format: "hh:mm  jYYYY/jMM/jDD",
                })}
              </td>
              <td>
                <CustomIcon
                  hoverTitle={t("detail")}
                  icon="fas fa-list"
                  onClick={() => {
                    setShowModal("DRIVER_TRANSACTION_MODAL");
                    setSelected(debt);
                  }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
};

export default Body;
